import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { RootComponent } from "./app/root.component";
import { environment } from "./environments";

if (environment.isProductionBuild) {
  enableProdMode();
}

bootstrapApplication(RootComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((error: unknown) => {
  throw error;
});
